import {useId, ReactNode} from 'react';
import classNames from 'classnames';

import {Radio} from '@udemy-v2/react-form-components';
import styles from './collapsible-purchase-section.module.scss';

export interface CollapsiblePurchaseSectionProps {
    title: ReactNode;
    children: ReactNode;
    expanded?: boolean;
    showRadio?: boolean;
    /** When true, renders a static header (GR-87 marketplace-only price box). */
    disableToggle?: boolean;
    onExpand?: () => void;
}

export const CollapsiblePurchaseSection = ({
    title,
    children,
    expanded = false,
    showRadio = true,
    disableToggle = false,
    onExpand,
}: CollapsiblePurchaseSectionProps) => {
    const contentId = useId();

    const handleClick = () => {
        if (!expanded) {
            onExpand?.();
        }
    };

    const titleContent = (
        <div className={styles['radio-controlled-title-wrapper']}>
            {showRadio && (
                <div className={styles['radio']}>
                    <Radio size={'large'} checked={expanded} readOnly={true} />
                </div>
            )}
            <div className={styles['radio-controlled-title']}>{title}</div>
        </div>
    );

    return (
        <div className={styles['panel']}>
            {disableToggle ? (
                <div className={classNames(styles['panel-toggler'], styles['panel-toggler-static'])}>
                    {titleContent}
                </div>
            ) : (
                <button
                    type="button"
                    aria-expanded={expanded}
                    aria-controls={contentId}
                    onClick={handleClick}
                    className={styles['panel-toggler']}
                >
                    {titleContent}
                </button>
            )}
            <div
                id={contentId}
                role="group"
                aria-hidden={!expanded}
                className={classNames({[styles['panel-content-collapsed']]: !expanded})}
            >
                <div className={styles['radio-controlled-content']}>{children}</div>
            </div>
        </div>
    );
};
